import React from 'react'
import i18n from './src/i18n'

export const wrapRootElement = ({ element }) => {
  return <>{element}</>
}
